import { useState } from "react";
import "./TopBanner.css";

const TopBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="top-banner">
      <div className="top-banner__content">
        <span className="top-banner__brand">HYPEX</span>

        <span className="top-banner__text">
          Where creator culture meets the festival
        </span>

        <a
          href="https://hypex.events/"
          target="_blank"
          rel="noopener noreferrer"
          className="top-banner__learn"
        >
          Learn more ↗
        </a>
      </div>

      <button
        className="top-banner__close"
        onClick={() => setIsVisible(false)}
        aria-label="Close banner"
      >
        ×
      </button>
    </div>
  );
};

export default TopBanner;